var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPoligon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.424,
    height: 28.715,
    viewBox: "0 0 22.424 28.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Poligon",
    transform: "translate(-52.965 -3023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7151",
    "data-name": "Path 7151",
    transform: "translate(71.097 3035.873) rotate(-135)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.061,0l6.074,6.07L0,6.061Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.061586856842041 1.413997173309326 L 2.41249942779541 5.063084602355957 L 9.71809196472168 5.068292140960693 L 6.061586856842041 1.413997173309326 M 6.061368465423584 -4.291534423828125e-06 L 12.13505840301514 6.070015430450439 L -1.9073486328125e-06 6.061365604400635 L 6.061368465423584 -4.291534423828125e-06 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7155",
    "data-name": "Path 7155",
    transform: "translate(61.546 3046.424) rotate(-135)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.061,0l6.074,6.07L0,6.061Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.061586856842041 1.413997173309326 L 2.41249942779541 5.063084602355957 L 9.71809196472168 5.068292140960693 L 6.061586856842041 1.413997173309326 M 6.061368465423584 -4.291534423828125e-06 L 12.13505840301514 6.070015430450439 L -1.9073486328125e-06 6.061365604400635 L 6.061368465423584 -4.291534423828125e-06 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7154",
    "data-name": "Path 7154",
    transform: "translate(75.389 3032.591) rotate(135)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.061,6.07,12.135,0,0,.009Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.061592578887939 4.656013965606689 L 9.718098640441895 1.001717209815979 L 2.412503480911255 1.006918668746948 L 6.061592578887939 4.656013965606689 M 6.061373710632324 6.070015907287598 L 3.493041958790855e-06 0.008635807782411575 L 12.13506317138672 -4.192123469692888e-06 L 6.061373710632324 6.070015907287598 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7152",
    "data-name": "Path 7152",
    transform: "translate(70.107 3027.301) rotate(135)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.061,0l6.074,6.07L0,6.061Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.061586856842041 1.413997173309326 L 2.41249942779541 5.063084602355957 L 9.71809196472168 5.068292140960693 L 6.061586856842041 1.413997173309326 M 6.061368465423584 -4.291534423828125e-06 L 12.13505840301514 6.070015430450439 L -1.9073486328125e-06 6.061365604400635 L 6.061368465423584 -4.291534423828125e-06 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7153",
    "data-name": "Path 7153",
    transform: "translate(65.815 3041.164) rotate(-135)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.061,6.07,12.135,0,0,.009Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.061583518981934 4.656018733978271 L 9.718093872070312 1.001723647117615 L 2.412501573562622 1.006931185722351 L 6.061583518981934 4.656018733978271 M 6.061363697052002 6.070020198822021 L 3.493041958790855e-06 0.008650338277220726 L 12.13506317138672 3.378295900802186e-07 L 6.061363697052002 6.070020198822021 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7156",
    "data-name": "Path 7156",
    transform: "translate(65.815 3051.715) rotate(-135)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.061,6.07,12.135,0,0,.009Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.061583518981934 4.656018733978271 L 9.718093872070312 1.001723647117615 L 2.412501573562622 1.006931185722351 L 6.061583518981934 4.656018733978271 M 6.061363697052002 6.070020198822021 L 3.493041958790855e-06 0.008650338277220726 L 12.13506317138672 3.378295900802186e-07 L 6.061363697052002 6.070020198822021 Z",
    stroke: "none",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoligon);
export default __webpack_public_path__ + "static/media/icon_poligon.cffac5746c962b55d8ee79beee633d60.svg";
export { ForwardRef as ReactComponent };